export default "https://legacy.eskolare-development.com/images/payment.png";